import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Wine, X } from 'lucide-react';
import { breathalyzerAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const BreathalyzerCaptureBanner = () => {
  const location = useLocation();
  const envPrefix = location.pathname.startsWith('/test') ? '/test' : '';
  const { isSupervisor, isAdmin } = useAuth();
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      if (!isSupervisor && !isAdmin) {
        setLoading(false);
        return;
      }

      try {
        const response = await breathalyzerAPI.getBannerStatus();
        setStatus(response.data);
      } catch (error) {
        console.error('Failed to fetch breathalyzer status:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [isSupervisor, isAdmin]);

  if (loading || dismissed || !status?.needs_capture || (!isSupervisor && !isAdmin)) {
    return null;
  }

  return (
    <div className="bg-violet-600 text-white px-4 py-2" data-testid="breathalyzer-capture-banner">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Wine className="w-5 h-5" />
          <span className="font-medium">Daily Random Breathalyzer Test</span>
          <span className="text-violet-200">
            {status.message}
          </span>
          <Link 
            to={`${envPrefix}/breathalyzer?capture=true`}
            className="bg-white text-violet-700 px-3 py-1 rounded-md text-sm font-semibold hover:bg-violet-100 transition-colors ml-2"
          >
            Record Test
          </Link>
        </div>
        <button 
          onClick={() => setDismissed(true)}
          className="hover:bg-white/20 rounded p-1"
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default BreathalyzerCaptureBanner;
